import React from 'react';
import { useAppLayout } from '../hooks/useAppLayout';
import { MobileShell } from './MobileShell';
import { DesktopShell } from './DesktopShell';
import { NativeMobileShell } from './NativeMobileShell';
import type { ShellRouteContext } from './shellRouteContext';

export interface AppShellContainerProps {
  route: ShellRouteContext;
  children: React.ReactNode;
}

/**
 * Choisit le shell selon le contexte :
 * - Capacitor (isNative) → NativeMobileShell (header Rintintin, safe-area, pas de footer marketing)
 * - Mobile web             → MobileShell (navbar existante + bottom nav)
 * - Desktop web            → DesktopShell (navbar + footer)
 */
export const AppShell: React.FC<AppShellContainerProps> = ({ route, children }) => {
  const { isNative, layout } = useAppLayout();

  if (isNative) {
    return <NativeMobileShell route={route}>{children}</NativeMobileShell>;
  }

  if (layout === 'mobile') {
    return <MobileShell route={route}>{children}</MobileShell>;
  }

  return <DesktopShell route={route}>{children}</DesktopShell>;
};
